import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import styles from "./card.module.scss";

export type CardSize = "default" | "sm" | "square";
export type CardState = "default" | "selected";

export interface CardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  size?: CardSize;
  state?: CardState;
  asChild?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, size = "default", state = "default", asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";

    const sizeClass = size === "default" ? styles.cardSizeDefault :
                     size === "sm" ? styles.cardSizeSm :
                     styles.cardSizeSquare;

    const stateClass = state === "default" ? styles.cardStateDefault :
                       styles.cardStateSelected;

    const cardClasses = [
      styles.card,
      sizeClass,
      stateClass,
      className
    ].filter(Boolean).join(" ");

    return (
      <Comp
        ref={ref as any}
        data-slot="card"
        className={cardClasses}
        {...props}
      />
    );
  }
);

export { Card };
